import store from '@/store'
import { getDatabase, ref, onValue } from 'firebase/database'
import { getFirebaseApp } from './firebase'

// Firebase Realtime Database 目前不穩定暫時設為 false，否則會持續 loading 無法登入
const FORCE_LOGOUT_ENABLED = false

// 儲存當前的監聽器取消函數
let currentUnsubscribeFunction = null

/**
 * 處理資料變更
 * @param {object} snapshot - Firebase 資料快照
 */
function handleDataChange (snapshot) {
  if (!snapshot.exists()) {
    // 未被強制登出
    store.commit('triggerForceLogout', false)
    return
  }

  const data = snapshot.val()
  const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo') || '{}')
  const { Account: account } = loginUserInfo

  // 檢查全社區強制登出
  if (data?.LockAll?.Lock === true) {
    store.commit('triggerForceLogout', true)
    return
  }

  // 檢查特定帳號強制登出（目前僅支援舊制帳號）
  if (account && data?.[account]?.Lock === true) {
    store.commit('triggerForceLogout', true)
    return
  }

  // 未被強制登出
  store.commit('triggerForceLogout', false)
}

/**
 * 清除所有現有的監聽器
 */
function clearExistingListeners () {
  if (typeof currentUnsubscribeFunction === 'function') {
    currentUnsubscribeFunction()
  }
  currentUnsubscribeFunction = null
}

/**
 * 初始化強制登出功能
 */
function forceLogoutUsersByCommunity () {
  // 清除之前的監聽器與狀態
  clearExistingListeners()

  if (!FORCE_LOGOUT_ENABLED) {
    store.commit('triggerForceLogout', false)
    return
  }

  store.commit('triggerForceLogout', null)

  // 初始化 Firebase
  const firebaseApp = getFirebaseApp('smartlife-3d231')
  const database = getDatabase(firebaseApp)

  // 如果已登入，要監聽是否強制登出
  const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo') || '{}')
  const { ComId: comId } = loginUserInfo
  if (comId) {
    // 監聽整個社區的強制登出設定
    const logoutRef = ref(database, `Logout/${comId}`)
    const unsubscribeLogout = onValue(logoutRef, handleDataChange)
    currentUnsubscribeFunction = unsubscribeLogout
  }
}

export { forceLogoutUsersByCommunity }
